import HomeLayout from "components/home/Home";

function Home(props: any) {

    return (
        <HomeLayout props={props} />
    );
}

export default Home;